/**
 * hls.js proxy loader for Web Player mode.
 *
 * hls.js internally issues fetch/XHR requests for the .m3u8 manifest,
 * sub-manifests, and every .ts segment. Those are cross-origin from
 * the provider's CDN → CORS blocks them in the browser and the player
 * dies with "manifestLoadError" before a single frame plays.
 *
 * This loader rewrites each URL to go through the backend
 * `/api/proxy/fetch?url=…` endpoint (with device-auth query params),
 * so hls.js effectively fetches everything same-origin. Native /
 * same-origin URLs pass through untouched.
 *
 * Usage:
 *   const hls = new Hls({ loader: makeProxyLoader() });
 */
import Hls from "hls.js";
import { webUrl } from "./webFetch";

/**
 * Returns a hls.js loader class that transparently rewrites URLs
 * through the backend proxy in Web Player mode.
 */
export function makeProxyLoader() {
  const Base = Hls.DefaultConfig.loader;

  return class ProxyLoader extends Base {
    load(context, config, callbacks) {
      if (context && context.url) {
        const proxied = webUrl(context.url);
        if (proxied !== context.url) {
          context.url = proxied;
        }
      }
      return super.load(context, config, callbacks);
    }
  };
}
